import { useState, useEffect } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { doc, onSnapshot } from 'firebase/firestore';
import { db, collections } from '@/lib/firebase';
import { UserData } from '@/types/user';

export function useUserData() {
  const { currentUser } = useAuth();
  const [userData, setUserData] = useState<UserData | null>(null);
  const [loading, setLoading] = useState(!!currentUser);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!currentUser) {
      setLoading(false);
      setUserData(null);
      return;
    }

    // Set up real-time listener for user data
    const userRef = doc(db, collections.users, currentUser.uid);
    const unsubscribe = onSnapshot(userRef, 
      (doc) => {
        if (doc.exists()) {
          setUserData({
            id: doc.id,
            ...doc.data()
          } as UserData);
          setError(null);
        } else {
          setUserData(null);
          setError('User data not found');
        }
        setLoading(false);
      },
      (error) => {
        console.error('Error fetching user data:', error);
        setError('Failed to load user data');
        setLoading(false);
      }
    );

    // Cleanup subscription
    return () => unsubscribe();
  }, [currentUser]);

  return { userData, loading, error };
}